import styled from "styled-components";

export const Styled404 = styled.section`
   display: flex;
   flex-direction: column;
   justify-content: center;
   align-items: center;
   font-size: 7vmax;
   min-height: 50vmax;
   padding: 8rem 2rem;
`